import Api from '@/services/api';
import qs from 'querystring';

export default {
  search(params, filters = [], hiddenFilter = '', page = 1, sortBy = 'date', sortDesc = false, fetchFacets = true) {

    return Api().post('/courrier_type/search', qs.stringify({
      'search': JSON.stringify(params),
      'filters': JSON.stringify(filters),
      'hiddenFilter': hiddenFilter,
      'page': page,
      'sortBy': sortBy,
      'sortDesc': sortDesc,
      'fetchFacets': fetchFacets
    }));
  },
  delete_courrier_type(data) {
    return Api().delete('/courrier_type/' + data.courrier_type_id);
  },
  update_courrier_type(data) {
    return Api().post('/courrier_type/' + data.courrier_type_id, qs.stringify({ data: JSON.stringify(data.courrier_type) }));    
  },
  create_courrier_type(data) {
    return Api().post('/courrier_type', qs.stringify({ data: JSON.stringify(data.courrier_type) }));    
  },
  courrier_type(data) {
    return Api().get('/courrier_type/' + data.courrier_type_id);
  }
}